import { render, staticRenderFns } from "./AuctionDetail.vue?vue&type=template&id=2effe868&"
import script from "./AuctionDetail.vue?vue&type=script&lang=js&"
export * from "./AuctionDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuctionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2effe868')) {
      api.createRecord('2effe868', component.options)
    } else {
      api.reload('2effe868', component.options)
    }
    module.hot.accept("./AuctionDetail.vue?vue&type=template&id=2effe868&", function () {
      api.rerender('2effe868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/auctions/views/components/AuctionDetail.vue"
export default component.exports